import { Code, ScrollArea, Stack, Text } from '@mantine/core'
import type { WidgetRendererProps } from './registry'

/**
 * Draws a widget nobody has written a renderer for yet.
 *
 * Deliberately plain rather than clever: its job is to prove the widget is
 * wired up end to end, and to be obviously a placeholder so it gets replaced.
 */
export function GenericWidget({ definition, payload }: WidgetRendererProps) {
  return (
    <Stack gap="xs" h="100%">
      <Text size="sm" c="dimmed">
        {definition.description}
      </Text>
      <ScrollArea h="100%" type="auto">
        <Code block style={{ fontSize: 11 }}>
          {JSON.stringify(payload.data, null, 2)}
        </Code>
      </ScrollArea>
    </Stack>
  )
}
